import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel = "查看全部" }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div>
        <div className="flex items-center gap-2.5">
          <span className="h-6 w-1.5 rounded-full bg-primary-500" aria-hidden="true" />
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        </div>
        {subtitle && <p className="mt-2 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}